import * as universal from '../entries/pages/_page.ts.js';

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/+page.ts";
export const imports = ["_app/immutable/nodes/3.DXt3_PAC.js","_app/immutable/chunks/Cew_q46a.js","_app/immutable/chunks/DiR_Syld.js","_app/immutable/chunks/DHDEAeFQ.js","_app/immutable/chunks/DcKRL2at.js","_app/immutable/chunks/Dh3qtgeV.js","_app/immutable/chunks/BwtdicTf.js","_app/immutable/chunks/zrRTLWHD.js","_app/immutable/chunks/zAv0u1wk.js","_app/immutable/chunks/B6Ikv-5C.js","_app/immutable/chunks/C-ONJZal.js","_app/immutable/chunks/BCt2Yrch.js"];
export const stylesheets = ["_app/immutable/assets/3.hfI2JAKE.css"];
export const fonts = [];
